module.exports = __webpack_public_path__ + "img/皮尔博格.png";